/**
 * Accesso con username e password (M2, 21/10/2026): POST /api/auth/login → token JWT (8 ore) + dati utente.
 * La sessione resta nel browser (localStorage) finché non si esce o il token scade: in quel caso il server risponde
 * 401 e l'app torna alla pagina di login. Gli account sono quelli della rubrica Predimain (es. "mrossi").
 */
export interface AuthUser { id: string; name: string; department: string; role: "technician" | "expert"; isAdmin?: boolean }
export interface Session { token: string; user: AuthUser }

const KEY = "mdt.session";

export function loadSession(): Session | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw) as Session;
    return s && s.token && s.user ? s : null;
  } catch { return null; }
}

export function saveSession(s: Session): void {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* storage non disponibile: la sessione dura solo la pagina */ }
}

export function clearSession(): void {
  try { localStorage.removeItem(KEY); localStorage.removeItem("mdt.apiKey"); } catch { /* ignora */ }
}

export function authHeaders(token: string): Record<string, string> {
  return { Authorization: `Bearer ${token}` };
}

export async function login(username: string, password: string): Promise<Session> {
  let r: Response;
  try {
    r = await fetch("/api/auth/login", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ username, password }) });
  } catch {
    throw new Error("Server non raggiungibile");
  }
  if (r.status === 401) throw new Error("Username o password non corretti");
  if (!r.ok) throw new Error(`Il server ha risposto ${r.status}`);
  const body = (await r.json()) as { token: string; user: AuthUser };
  return { token: body.token, user: body.user };
}
